import localforage from 'localforage'
import moment from 'moment'
import { EntityCollection } from '@/assets/js/JMan/EntityCollection'

export class EntityCache {
	constructor (opts = {name: "JManCache", storeName: "Entities"}) {
		this.db = localforage.createInstance(opts);

		this.iterator
	}

	async get (uuid) {
		return await this.db.getItem(uuid);
	}

	put (entity) {
		this.db.setItem(entity.id, entity).catch(err => console.error("DB ERR", err, entity));
	}

	clear () {
		this.db.clear();
	}

	iterate (fn) {
		return this.db.iterate(fn);
	}

	async values () {
		let values = [];
		await this.db.iterate( (value) => {
			values.push(value);
		});
		return values;
	}

	async filter (options = {}) {

		return await EntityCollection.filter(await this.values(), options);

	}

};



// WEBPACK FOOTER //
// ./src/assets/js/JMan/EntityCache.js